import { z } from 'zod';

export const adminProductCursorSchema = z
    .union([
        z.object({ t: z.literal('created'), ts: z.number(), id: z.string().uuid() }),
        z.object({ t: z.literal('updated'), ts: z.number(), id: z.string().uuid(), fence: z.number() }),
    ])
    .nullable();

export type AdminProductCursorSchema = z.infer<typeof adminProductCursorSchema>;
